import * as React from 'react'
import { BodyWithMenu } from '../../components/organisms/Menu'
import { getProjects } from '../../globals/ApiHooks';
import Project from '../../shared/Project';
import { lang } from '../../globals/Translations';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import ProjectCard from '../../components/atoms/ProjectCard'
import { IsHorizontalMobile, useWindowSize } from '../../globals/UIHooks';
import { getProjectStatus, ProjectStatus } from '../../shared/ProjectStatus';
import colors from '../../globals/colors';
import { fbDateToUnix } from '../../shared/Globals';

const Margin: React.FC<{ list?: Project[] }> = ({ list }) => list && list.length > 0 ? <div style={{ width: '100%', height: 60 }}></div> : <></>

const ProjectSection: React.FC<{ items?: Project[], title: TranslatedTerms }> = ({ items, title }) => {
  const { width } = useWindowSize()

  if (!items || items.length === 0) return <></>

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <h2 style={{
          marginTop: 30, marginBottom: 45, paddingBottom: 12, borderBottomStyle: 'solid',
          borderBottomWidth: 8, borderBottomColor: colors.primary
        }}>{lang(title)}</h2>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: IsHorizontalMobile(width) ? "1fr" : "1fr 1fr", gap: "30px 30px" }}>
        {items && items.map((item, key) => <ProjectCard key={key} project={item} />)}
      </div>
    </>
  )
}

const now = (new Date()).toString()

const sortProjectsByDate = (projects?: Project[]) => projects && projects.sort((b, a) => fbDateToUnix(a.state.interestStartDate || now) - fbDateToUnix(b.state.interestStartDate || now))

export const ProjectsPage: React.FC = () => {
  const [projects, setProjects] = React.useState<Project[]>()
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    (async () => {
      setLoading(true)
      const project = await getProjects()
      setProjects(project)
      setLoading(false)
    })()
  }, [])

  const openForInvestments = projects && projects.filter((item) => getProjectStatus(item) === ProjectStatus.OPEN_FOR_INVESTMENT)
  const completed = projects && projects.filter((item) => [ProjectStatus.PROJECT_COMPLETED, ProjectStatus.FAILED].includes(getProjectStatus(item)))
  const comingSoon = projects && projects.filter((item) => getProjectStatus(item) === ProjectStatus.COMMING_SOON)
  const inProgress = projects && projects.filter((item) => [ProjectStatus.INVESTOR_RECIVING_INTREST, ProjectStatus.FAILD_PROCESS, ProjectStatus.WAITING_FOR_START].includes(getProjectStatus(item)))


  return (
    <BodyWithMenu loading={loading}>
      <h1 style={{ margin: 0 }}>{lang(TranslatedTerms.PROJECTS)}</h1>
      <ProjectSection title={TranslatedTerms.PROJECT_OPEN_FOR_INVESTMENT} items={sortProjectsByDate(openForInvestments)} />
      <Margin list={openForInvestments} />
      <ProjectSection title={TranslatedTerms.PROJECT_COMMING_SOON} items={sortProjectsByDate(comingSoon)} />
      <Margin list={comingSoon} />
      <ProjectSection title={TranslatedTerms.PROJECTS_IN_PROGRESS} items={sortProjectsByDate(inProgress)} />
      <Margin list={inProgress} />
      <ProjectSection title={TranslatedTerms.PROJECTS_IN_COMPLETED} items={sortProjectsByDate(completed)} />
    </BodyWithMenu>
  )
};
